var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mainLayout'),_c('checkAcces',{attrs:{"pageAccess":"admin"}}),_c('div',{staticClass:"mainContent"},[_c('userManagement',{attrs:{"userStatus":"labo"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }